import React, { useState, useEffect, useRef } from "react";
import useAxios from "../../hooks/useAxios";
import { useAuth } from "../../contexts/AuthContext";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { ProgressBar } from "primereact/progressbar";
import { Tag } from "primereact/tag";
import { Panel } from "primereact/panel";

const MobigapStatus = () => {
  const { user } = useAuth();
  const { response, loading, fetchData } = useAxios();

  const [inputText, setInputText] = useState("");
  const [results, setResults] = useState([]);

  const toast = useRef(null);
  const dt = useRef(null);

  useEffect(() => {
    if (!response) return;
    if (response.status === "success" && response.data) {
      setResults(response.data);
    } else if (response.status === "error") {
      toast.current.show({ severity: "error", detail: response.message, life: 3000 });
    }
  }, [response]);

  const handleCheckStatus = () => {
    const numbers = inputText
      .split("\n")
      .map((n) => n.trim())
      .filter((n) => n.length > 0);

    if (numbers.length === 0) {
      toast.current.show({ severity: "warn", detail: "Введите номера", life: 3000 });
      return;
    }

    fetchData({
      method: "post",
      url: "/api/mobigap/check-status",
      data: { numbers },
    });
  };


  const statusBodyTemplate = (rowData) => {
    if (rowData.status === "error") {
      return <Tag severity="danger" value={rowData.message} />;
    }
    const severityMap = { Active: "success", Blocked: "danger" };
    return (
      <Tag
        severity={severityMap[rowData.statusText] || "info"}
        value={rowData.statusText}
      />
    );
  };

  if (!user) return null;

  return (
    <div className="flex justify-content-center">
      <div style={{ width: "100%", maxWidth: "900px", padding: "1rem" }}>
        <Toast ref={toast} position="top-right" />

        <Panel header="Проверка статуса номеров Mobigap" className="mb-4">
          <div className="p-fluid">
            <label className="block mb-2 font-bold">
              Введите номера (1 строка = 1 номер, формат 992XXXXXXXXX)
            </label>
            <InputTextarea
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              rows={8}
              placeholder={"992XXXXXXXXX\n992XXXXXXXXX\n992XXXXXXXXX"}
              className="mb-3"
            />
            <div className="flex gap-2">
              <Button
                label="Проверить статус"
                icon="pi pi-search"
                className="p-button-primary"
                onClick={handleCheckStatus}
                loading={loading}
              />
            </div>
          </div>
        </Panel>

        {loading && <ProgressBar mode="indeterminate" style={{ height: "6px" }} />}

        {results.length > 0 && (
          <DataTable
            ref={dt}
            value={results}
            size="small"
            showGridlines
            stripedRows
            exportFilename="mobigap_status"
            style={{ fontSize: "0.85rem" }}
          >
            <Column field="msisdn" header="Номер" sortable />
            <Column header="Статус" body={statusBodyTemplate} sortable field="statusText" />
          </DataTable>
        )}
      </div>
    </div>
  );
};

export default MobigapStatus;
